import { Box, LinearProgress } from '@mui/material';
import React from 'react';

export const LoadingBar = ({ loading }: {loading: boolean}) => {
  return <Box sx={{ width: '100%', height: 0, padding: (theme)=>theme.spacing(0, 0, 2, 0) }}>
    {loading ? <LinearProgress /> : null}
  </Box>;
};